import { InflateRequestMode } from '@sccs/types';
import { SharedRequestConfiguration, VehicleParameterUnion } from '../../types/GeneralParameter';
import { OptionalOneSearchGraphQlResponseWithRawData, OptionalResponseTypes } from '../../types/GeneralTypes';
import { SearchAlternativeReponseWithId } from '../../types/dls/dls-response/SearchResponseDto';
import { RawData, RawDataSchema } from '../../types/raw/RequestParams';
import { createSpecificClient } from '../clients/ClientFactory';
import { DlsSearch, FilterCriteriaDlsSearch } from '../clients/dls/DlsClientSearch';
import { OneSearchVehicleTileDataParams } from '../clients/onesearch/graphql/OneSearchGraphQL';

export async function getClientAndFetchData(
  config: SharedRequestConfiguration,
  requestParams: VehicleParameterUnion,
  rawData?: RawData,
): Promise<OptionalResponseTypes> {
  if (
    (config.mode === InflateRequestMode.SIMPLE_PRICE || config.mode === InflateRequestMode.BANNER_CAMPAIGN) &&
    config.isFoc
  ) {
    const oneSearchClient = createSpecificClient(config, requestParams);
    const dlsParams: DlsSearch = {
      market: requestParams.market,
      lang: requestParams.lang,
      includeFirstVehicles: 1,
      numberOfPrimaryVehicles: 0,
      numberOfSecondaryVehicles: 0,
      sort: config.sortType,
      filterCriteria: {
        modelIdentifier: (requestParams as OneSearchVehicleTileDataParams).modelIdentifier, // filterVehicleClasses((requestParams as OneSearchVehicleTileDataParams).modelIdentifier),
        brand: (requestParams as OneSearchVehicleTileDataParams).brand,
        bodyType: (requestParams as OneSearchVehicleTileDataParams).bodyType,
        fuelType: (requestParams as OneSearchVehicleTileDataParams).fuelType,
        campaign: (requestParams as OneSearchVehicleTileDataParams).campaigns,
      } as FilterCriteriaDlsSearch,
    };
    const dlsClient = createSpecificClient({ ...config, isFoc: false }, dlsParams);
    const oneSearchResponse = await oneSearchClient.getResponse();
    const dlsResponse = await dlsClient.getResponse();
    if (config.mode === InflateRequestMode.BANNER_CAMPAIGN) {
      return {
        ...(oneSearchResponse as OptionalOneSearchGraphQlResponseWithRawData),
        url: (dlsResponse as SearchAlternativeReponseWithId).url,
        responseTypeId: 'OneSearchGraphQlWithRawData',
      };
    } else {
      if (rawData?.schema !== RawDataSchema.CAMPAIGN_TILE) throw Error('No Raw Data provided');
      const campaignRawData = rawData.data;

      return {
        ...(oneSearchResponse as OptionalOneSearchGraphQlResponseWithRawData),
        url: (dlsResponse as SearchAlternativeReponseWithId).url,
        rawData: campaignRawData,
        responseTypeId: 'OneSearchGraphQlWithRawData',
      };
    }
  } else if (config.mode === InflateRequestMode.SIMPLE_PRICE || config.mode === InflateRequestMode.BANNER_CAMPAIGN) {
    const dlsClient = createSpecificClient(config, requestParams);
    const dlsResponse = await dlsClient.getResponse();
    if (config.mode === InflateRequestMode.BANNER_CAMPAIGN) {
      return {
        ...(dlsResponse as SearchAlternativeReponseWithId),
        responseTypeId: 'SearchResponseDTO',
      };
    } else {
      if (rawData?.schema !== RawDataSchema.CAMPAIGN_TILE) throw Error('No Raw Data provided');
      const campaignRawData = rawData.data;
      return {
        ...(dlsResponse as SearchAlternativeReponseWithId),
        rawData: campaignRawData,
        responseTypeId: 'SearchResponseDTO',
      };
    }
  } else {
    const client = createSpecificClient(config, requestParams);
    return await client.getResponse();
  }
}
